import { type InjectionKey } from 'vue'
import type { Measurable } from '../components/image-preview'
import type {
  PriceChooseOption,
  PriceGroupNameValue
} from '../components/popup-price-group/types'
import { ImprintMethodModel, ProductSpecModel } from '../model'
import {type  MiniSpecGroup } from '../types'

// // 全部变成可选项，剔除priceList
// export type AppUpdateViewOptions = Partial<
//   Omit<UpdateViewOptions, 'priceList'>
// > & {
//   isBlank?: boolean;
// };

// export type AppContextProvide = {
//   // isBlank: boolean;
//   currentPriceList: PriceInfo[];
//   // selectedProductSpecList: ProductSpecModel[];
//   // selectedImprintMethodList: ImprintMethodModel[];
//   // selectedSpecList: SpecModel[];
//   // selectedAddonList: SpecModel[];
//   updateView: (options?: AppUpdateViewOptions) => void;
//   getPriceList: (options?: AppUpdateViewOptions) => PriceInfo[];
// };

// export const AppContextKey: InjectionKey<AppContextProvide> = Symbol('app')

export type ShowPopupPriceGroupProvideOption = {
  isBlank?: boolean
  type: PriceChooseOption
  value: PriceGroupNameValue
  productSpecList?: ProductSpecModel[]
  specList?: MiniSpecGroup[]
  addonList?: MiniSpecGroup[]
  imprintMethodList?: ImprintMethodModel[]
}

export type ShowBigImageProvide = {
  show: (imgUrl: string, imgText: string, target?: Measurable) => void
  hide: () => void
}

export type ShowPriceGroupProvide = (
  options: ShowPopupPriceGroupProvideOption
) => Promise<any>

export const SHOW_PRICE_GROUP_KEY: InjectionKey<ShowPriceGroupProvide> =
  Symbol('show_price_group')

export const SHOW_BIG_IMAGE_KEY: InjectionKey<ShowBigImageProvide> = Symbol(
  'show_big_image_popup'
)
